// src/context/SearchContext.js
import React, { createContext, useState, useContext } from 'react';
import { apiSearchAddress } from '../services/api'; // Lo añadiremos después
import { useNotification } from './NotificationContext';

const SearchContext = createContext(null);

export const SearchProvider = ({ children }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { showNotification } = useNotification();

  const performSearch = async (address) => {
    setIsLoading(true);
    setSearchResult(null);
    setIsSearchOpen(true);
    try {
      const response = await apiSearchAddress(address);
      setSearchResult(response.data);
    } catch (error) {
      setSearchResult({ error: error.response?.data?.message || 'Address not found' });
      showNotification(error.response?.data?.message || 'Address not found', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const closeSearch = () => {
    setIsSearchOpen(false);
    setSearchResult(null);
  };

  const value = { isSearchOpen, searchResult, isLoading, performSearch, closeSearch };

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
};

export const useSearch = () => {
  return useContext(SearchContext);
};
